import { css, styled } from '@creditas-ui/system'

export const GridItem = styled('div')(
  ({ area }) => css`
    grid-area: ${area};
  `,
)
